import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class GetEmailTemplatesCommand extends IRequestCommand<
  IGetEmailTemplatesResponse,
  ErrorDetails,
  IGetEmailTemplatesParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = "contractor/{contractorId}/emailsTemplates"

  public override setParameters(parameters: IGetEmailTemplatesParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{contractorId}',
      parameters.idContractor ? parameters.idContractor.toString() : ''
    );
    this._commandUrl = this._commandUrl + (parameters.language ? '?language=' + parameters.language : '');
    this._commandBody = parameters;
  }
}

export interface IGetEmailTemplatesParameters {
  idContractor: number;
  language?: string;
}

export interface IGetEmailTemplatesResponse extends Array<IEmailTemplate> {
}

export interface IEmailTemplate {
  id: number;
  userId: number;
  html: string;
  logoPlacement: string;
  languageCode: string;
  userType: string;
  updateDate: string;
  emailVariables: string;
}
